export default function (state, data) {
    state.load = false;
    for (let k in data) {
        switch (k) {
            case 'opened':
                if (data[k]) {
                    for (let kk in data[k]) {
                        if (typeof state.opened[kk] !== 'undefined' && kk !== 'list') state.opened[kk] = data.opened[kk];
                    }
                }
                break;
            default:
                if (typeof state[k] !== 'undefined') state[k] = data[k];
        }
    }
    state.filters = [];
}